import React from "react";
import NewsContainer from "../containers/NewsContainer";

export default function News() {
  return <NewsContainer />;
}
